module.exports = __webpack_public_path__ + "img/uparw.3562cba2.svg";